import { useState } from 'react'
import { Card, Stack, Alert, Box, Typography, Switch, FormControlLabel } from '@mui/material'
import FloodSummary from './flood/FloodSummary'
import FloodDepth from './flood/FloodDepth'
import { useCurrentUser } from '../../../hooks/users'
import type { MetricDataFilters } from '../../../hooks/analytics'
import type { CanonicalPeriod, EmissionTier } from '../common'

const ADAPTATION_SCALE = 0.7
const FLOOD_BARRIER_HEIGHT_METERS = 0.6

type PropertyFloodProps = {
  propertyId: number
  emissionTier: EmissionTier
  selectedPeriod: CanonicalPeriod
  filters?: MetricDataFilters | null
}

const PropertyFlood = ({ propertyId, emissionTier, selectedPeriod, filters }: PropertyFloodProps) => {
  const { data: currentUser } = useCurrentUser()
  const isDev = process.env.NODE_ENV !== 'production'
  const isDemoOrg = currentUser?.organisation?.id === 4 || currentUser?.organisation?.id === 990
  const showAdaptationToggle = isDev || isDemoOrg
  const [adaptationEnabled, setAdaptationEnabled] = useState(true)
  const adaptationFactor = showAdaptationToggle && adaptationEnabled ? ADAPTATION_SCALE : 1

  if (!propertyId) return <Alert severity="info">Select a property to view flood metrics.</Alert>

  return (
    <Stack spacing={4}>
      {showAdaptationToggle && (
        <Card sx={{ p: 2 }}>
          <Stack
            spacing={2}
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="subtitle1">Adaptation installed: Flood Barrier (60cm)</Typography>
              {/* <Typography variant="body2" color="text.secondary">
                
              </Typography> */}
            </Box>
            <FormControlLabel
              control={
                <Switch checked={adaptationEnabled} onChange={event => setAdaptationEnabled(event.target.checked)} />
              }
              label={adaptationEnabled ? 'Enabled' : 'Disabled'}
            />
          </Stack>
        </Card>
      )}
      <Card sx={{ p: 3 }}>
        <FloodSummary
          propertyId={propertyId}
          emissionTier={emissionTier}
          selectedPeriod={selectedPeriod}
          adaptationFactor={adaptationFactor}
          filters={filters}
        />
      </Card>
      <Card sx={{ p: 3 }}>
        <FloodDepth
          propertyId={propertyId}
          emissionTier={emissionTier}
          filters={filters}
          showBarrierHeight={showAdaptationToggle && adaptationEnabled}
          barrierHeightMeters={FLOOD_BARRIER_HEIGHT_METERS}
        />
      </Card>
    </Stack>
  )
}

export default PropertyFlood
